export default "__VITE_ASSET__B2bi3nfw__"